<template>
  <div id="ASINsDetailed">
    <div data-html2canvas-ignore="true" class="customdim" v-show="loader">
      <!-- <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div> -->
      <Loader />
    </div>
    <div class="container-fluid mt-2" v-if="viewASINsDetailedData">
      <!-- <div class="row mt-2">
        <div class="col-12">
          <div class="card" v-for="(data, i) of viewASINsDetailedData" :key="'lqsgraph' + i">
            <lqs-card :viewLqsListingdata="data.lqs_analysis" :viewLqsGraph="data.total" :timestamp="data.timestamp"
              :asinData="data.asins" />
          </div>
        </div>
      </div> -->
      <LqsCard :viewASINsDetailedData="viewASINsDetailedData" :storeLqsDataByMonthGroup="storeLqsDataByMonthGroup"
        ref="childComp" keyCheck="true" />
      <div class="card" v-if="!showDataKey && loader">
        <div class="onLoadingData text-center mt-0">{{ translatedLang["Loading"][selectedLanguage.key] }}...</div>
      </div>
      <div class="card" v-else-if="!showDataKey && !loader">
        <div class="text-danger d-flex justify-content-center border border-danger rounded mt-1 p-2 noData">
          {{ translatedLang["No Data Available"][selectedLanguage.key] }}.
        </div>
      </div>
    </div>
    <div v-else class="no-data">{{ translatedLang["No Data"][selectedLanguage.key] }}!</div>
  </div>
</template>

<script>
import Loader from "../Components/Loader.vue";
import LqsCard from "./LqsCard.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "LqsAnalyser",
  components: { LqsCard, Loader },

  data: function () {
    return {
      viewASINsDetailedData: [],
      ASINId: this.$route.params.ASINId,
      loader: true,
      storeLqsDataByMonthGroup: null,
      showDataKey: false
    };
  },

  mounted() {
    this.getASINsDetails();
  },
  computed:{
    ...mapState("DemoStore", ["selectedLanguage", "translatedLang"]),

  },
  methods: {
    ...mapActions("DemoStore", [
      "setSelectedLanguage",
      "initializeTranslation",
    ]),
    sortAndGroupByMonth(data) {
      const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ];
      data.forEach(item => {
        const date = new Date(item.timestamp);
        item.monthIndex = date.getMonth();
      });
      data.sort((a, b) => a.monthIndex - b.monthIndex);
      const groupedData = {};
      data.forEach(item => {
        const monthName = monthNames[item.monthIndex];
        if (!groupedData[monthName]) {
          groupedData[monthName] = [];
        }
        groupedData[monthName].push(item);
      });
      return groupedData;
    },

    getASINsDetails() {
      let self = this;
      self.loader = true;
      let payload = {
        asin: this.ASINId,
        start: this.$route.params.startDate,
        end: this.$route.params.endDate,
        language: this.$store.state.DemoStore.selectedLanguage.key,
      };
      const url = "/api/v2/spider/viewasin";
      self.$http
        .post(url, payload)
        .then((response) => {
          // if (Object.keys(response.data).length)
          self.showDataKey = response.data.data_present;
          self.viewASINsDetailedData = response.data.data;
          this.storeLqsDataByMonthGroup = null;
          this.storeLqsDataByMonthGroup = this.sortAndGroupByMonth(response.data.data.slice(1));
          this.$refs.childComp.gaugeChart(response.data.data[0].total);
          self.loader = false;
        })
        .catch((err) => {
          self.loader = false;
          console.log("err", err);
        });
    },
  },
};
</script>

<style scoped>
.space-between {
  display: flex;
  justify-content: space-between;
}

.flex-start {
  display: flex;
  justify-content: start;
}

.mainHeading {
  color: #4e4e4e;
  margin-bottom: 0;
  font-size: 1.3125rem;
}

.secondaryHeading {
  color: #4e4e4e;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: bold;
}

.textColor {
  color: #818890 !important;
}

.flex-start {
  display: flex;
  justify-content: flex-start;
}

.inputBox {
  height: 30px;
  border: 1px solid silver;
  display: flex;
  justify-content: start;
  background: white;
}

.inputBox input {
  border-radius: 0px;
  border: none !important;
}

.sideBorder {
  border-right: 1px solid #c1c1c1;
}

input:focus {
  outline: none !important;
  box-shadow: none !important;
}

.trueIcon {
  color: #64ac94 !important;
}

.graphHeading {
  font-weight: 600 !important;
  font-size: 20px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  font-family: "poppins";
}

.falseIcon {
  color: #ff0000 !important;
}

.cardButton {
  margin-left: 10px;
}

.productCart {
  display: flex;
  justify-content: space-between;
  padding: 10px;
}

.productImg {
  width: 200px;
}

.product-title {
  font-size: 18px;
}

.productImg img {
  width: 100%;
}

.graphCount {
  font-size: 24px;
  color: "#533a79";
  font-weight: 700;
}

.asinBadge {
  background: "#9683b3";
}

.cross-icon {
  color: black;
  background: white;
}

.crossIcon {
  cursor: pointer;
  font-size: 8px;
}

.space-between {
  display: flex;
  justify-content: space-between;
}

thead {
  background: none;
  font-family: sans-serif;
  background: #9683b3;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
}

tbody {
  font-family: sans-serif;
  font-size: 13px;
}

.pinkColor {
  background: rgb(255 185 185);
  font-weight: bold;
}

.skyColor {
  background: rgb(199 224 255);
  font-weight: bold;
}

.no-data {
  font-size: 16px;
  text-align: center;
  padding: 10px;
  color: red;
}

.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButton:hover {
  background: var(--accent_color-80);
}

.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}

.noData {
  border: 1px solid #fbb1b1;
  border-radius: 5px;
  padding: 10px;
  background: #fff7f7;
}

/* 
.borderHeading {
  border-bottom: 1px solid #D4D4D4;
  font-size: 16px;
  font-weight: 500 !important;
  color: var(--primary_brand) !important;
}

.productHeadingContainer a {
  color: #0463BA;
  font-size: 16px;
  font-weight: 500;
  line-height: 25px;
  text-decoration: underline;
}

.copyBreakdownContainer .copyBreakdownHeading {
  background-color: #009688CC !important;
  color: #fff !important;
}

.breakdownSideBorder {
  border: 1px solid #D9D9D9;
  border-radius: 15px;
}

.breakDownHeading {
  font-size: 20px;
  color: #fff;
  font-weight: 500;
  border-radius: 15px;
}

.breakDownHeading:focus {
  box-shadow: none !important;
}

.mediaBreakdownContainer .mediaBreakdownHeading {
  background-color: #6956E5CC !important;
  color: #fff !important;
}

.reviewBreakdownContainer .reviewBreakdownHeading {
  background-color: #FD5542CC !important;
  color: #fff !important;
}

.showAsinHeading {
  font-size: 16px;
  font-weight: 500;
}

.breakdownContentClass {
  color: #5E5E5E;
  font-size: 14px !important;
  border-bottom: 1px solid #D4D4D4;
}

.checkIconBreakdown {
  background-color: #50B767 !important;
}

.crossIconBreakdown {
  background-color: #8C0000 !important;
}

.breakdownLables h5,
.breakdownCollapsedFooter h5,
.breakdownLables p,
.breakdownCollapsedFooter p,
.breakdownLablesRed h5,
.breakdownLablesRed p {
  font-size: 14px !important;
}

.breakdownLables h5,
.breakdownCollapsedFooter h5,
.breakdownLablesRed h5 {
  font-weight: 500;
  color: #000000;
}

.breakdownLables p,
.breakdownCollapsedFooter p,
.breakdownLablesRed p {
  font-weight: 400;
  color: #5E5E5E;
}

.breakdownLablesRed h5,
.breakdownLablesRed p {
  color: #8C0000;
}

.breakdownCollapsedFooter button {
  background: #065559;
  padding: 8px 16px;
}

.breakdownCollapsedFooter>div {
  background-color: #F1F1F1CC;
  border-radius: 15px;
}

.breakdownCollapsedFooter {
  border-top: 1px solid #D9D9D9;
}

.breakdownIssueCount {
  background-color: #A11E26;
  font-size: 14px !important;
  font-weight: 500 !important;
}

.historyBorder {
  border: 1px solid #D9D9D9;
}

.historyDate {
  border-right: 1px solid #D9D9D9;
}

button.primarycolorShow {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 6px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: 100;
  font-size: 14px;
}

button.primarycolorShow:hover {
  color: white;
  background: var(--primary_brand-80);
}

.highcharts-series-group .highcharts-series path {
  fill: #065559 !important;
}

.monthNameHeading {
  color: #000000;
  font-size: 16px;
  font-weight: 500;
}

.bgInfoColor {
  color: #818181;
}

.lastUpdatedDate {
  border: 1px solid #065559 !important;
}

.lastUpdatedDate .btn {
  color: #065559 !important;
  font-size: 13px !important;
  border: 0 !important;
  cursor: text !important;
}

.lastUpdatedDate .btn:focus {
  box-shadow: none !important;
} */
</style>
